<template>
    <div>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    @click="dialog_query_standard = true"
                    class="mr-5"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon color="primary">mdi-download</v-icon>
                </v-btn></template
            >
            <span>Query standard</span>
        </v-tooltip>
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    @click="verificaQuery()"
                    v-bind="attrs"
                    v-on="on"
                    class="mr-5"
                >
                    Verifica
                </v-btn></template
            >
            <span>Prova query</span>
        </v-tooltip>
        <p v-if="id_query > 0" style="margin-top: 5px; margin-bottom: 0px">
            Questo messaggio è selezionato da query standard.
        </p>
        <QueryEditor
            :key="query_mex.query"
            v-model="query_mex"
            @analyze="checkAnalyze"
        />
        <!-- Dialog con il risultato della verifica della query -->

        <v-dialog v-model="dialog_verifica" width="unset">
            <v-card min-width="600px">
                <v-toolbar
                    class="white--text"
                    color="indigo"
                    style="position: sticky; top: 0px; z-index: 1"
                    dense
                >
                    <v-toolbar-title>Risultato query</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <!-- Bottone di chiusura -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="dialog_verifica = false"
                                small
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="error"> mdi-close </v-icon>
                            </v-btn>
                        </template>
                        <span>Annulla</span>
                    </v-tooltip>
                </v-toolbar>
                <v-card-text class="mt-5 mb-0 pb-5">
                    <v-data-table
                        height="30vh"
                        fixed-header
                        :headers="headers"
                        :items="risultato_test"
                    >
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- Dialog query standard -->

        <v-dialog v-model="dialog_query_standard" width="unset">
            <v-card min-width="600px">
                <v-toolbar
                    class="white--text"
                    color="indigo"
                    style="position: sticky; top: 0px; z-index: 1"
                    dense
                >
                    <v-toolbar-title>Query standard</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <!-- Bottone di salvataggio -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="
                                    salva();
                                    dialog_query_standard = false;
                                "
                                small
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="success"> mdi-floppy </v-icon>
                            </v-btn>
                        </template>
                        <span>Salva</span>
                    </v-tooltip>
                    <v-spacer></v-spacer>
                    <!-- Bottone di chiusura -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="dialog_query_standard = false"
                                small
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="error"> mdi-close </v-icon>
                            </v-btn>
                        </template>
                        <span>Annulla</span>
                    </v-tooltip>
                </v-toolbar>
                <v-card-text class="mt-5 mb-0 pb-5">
                    <v-row class="ml-5 mb-5" align="center" justify="center">
                        <v-col cols="6">
                            <v-autocomplete
                                background-color="#ffffff"
                                hide-details
                                :item-text="(e) => e.titolo"
                                return-object
                                :items="lista_query_standard"
                                label=""
                                v-model="query_standard"
                            >
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import QueryEditor from "@/components/GRAPH/Dashboard/Editor/QueryParser/QueryEditor.vue";

export default {
    name: "QueryMessaggio",
    components: { QueryEditor },
    props: ["selez", "query_mod", "database"],
    data() {
        return {
            overlay: false,
            query_mex: this.query_mod
                ? { query: this.query_mod }
                : this.selez
                ? { query: this.selez.query_messaggio }
                : { query: "" },
            id_query: this.selez ? this.selez.id_query : null,
            check_save: false,
            dialog_verifica: false,
            dialog_query_standard: false,
            headers: [],
            risultato_test: [],
            lista_query_standard: [],
            query_standard: {},
        };
    },

    methods: {
        checkAnalyze(status) {
            this.check_save = !status;
            this.$emit("check_save_mex", this.check_save);
        },

        getQueryStandard() {
            let request = {
                controller: "notice",
                method: "POST",
                richiesta: {
                    action: "getquery",
                    token: localStorage.user_token,
                },
            };

            this.$store.dispatch("api6", request).then((res) => {
                this.overlay = false;
                if (res.data.result.lenght != 0) {
                    this.lista_query_standard = res.data.result;
                    if (this.id_query > 0) {
                        this.lista_query_standard.forEach((q) => {
                            if (q.id_query == this.id_query) {
                                this.query_standard = q;
                            }
                        });
                    }
                } else {
                    console.log("Non ci sono query.");
                }
            });
        },

        salva() {
            this.query_mex.query = this.query_standard.query;
            this.id_query = this.query_standard.id_query;
            console.log(this.query_mex.query);
            this.query_standard = "";
        },

        verificaQuery() {
            // Chiamata testSQL passando query_mex per popolare risultato_test e headers

            let request = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "performquery",
                    query_string: this.query_mex.query,
                    token: localStorage.user_token,
                    database_type:
                        this.database != null
                            ? this.database.db_type.toLowerCase()
                            : null,
                    connection_string:
                        this.database != null
                            ? this.database.connection_string
                            : null,
                },
            };
            this.overlay = true;
            this.$store.dispatch("api", request).then((res) => {
                this.overlay = false;
                if (res.data.result != null) {
                    this.risultato_test = res.data.result.Table;
                    this.headers = [];
                    for (let field in res.data.result.Table[0]) {
                        this.headers.push({
                            text: field,
                            value: field,
                            sortable: false,
                        });
                    }
                    console.log(this.headers);
                } else {
                    console.log("Non ci sono query.");
                }
                this.dialog_verifica = true;
            });
        },
    },

    computed: {},

    watch: {},

    mounted() {
        this.getQueryStandard();
    },
};
</script>
<style scoped></style>
